import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { setBreadcrumbsList } from 'src/store/breadcrumbs';

import { Tabs } from 'src/components';
import { BREADCRUMBS_DATA, ROUTE } from 'src/constants';

import './clientAgreement.scss';

export const ClientAgreement = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const options = [
    { to: ROUTE.PRIVACY_POLICY, label: t('documentation:privacyPolicy'), is_active: false },
    { to: ROUTE.RETURN_POLICY, label: t('documentation:returnPolicy'), is_active: false },
    { to: ROUTE.CLIENT_AGREEMENT, label: t('documentation:clientAgreement'), is_active: true },
  ];

  useEffect(() => {
    dispatch(setBreadcrumbsList(BREADCRUMBS_DATA.PRIVACY_POLICY));
  }, [dispatch]);

  return (
    <div className="client-agreement">
      <div className="client-agreement-content">
        <div className="client-agreement-tabs">
          <Tabs options={options} />
        </div>

        <div className="client-agreement-section">
          <h1 className="client-agreement-title">
            <blue-text>Client</blue-text> Agreement
          </h1>

          <div dangerouslySetInnerHTML={{ __html: t('policies:clientAgreementDescription') }}></div>
        </div>
      </div>
    </div>
  );
};
